// extracted by mini-css-extract-plugin
export default {"scrollbar":"HVDropdpwnScroll_module-JLWYPEBZ_scrollbar__zCj1d","thumb":"HVDropdpwnScroll_module-JLWYPEBZ_thumb__aKoGN"};